import imageField from 'molecules/Image/config';

import type { Input } from '@builder.io/sdk';

const leadershipFields = [
  {
    name: 'type',
    type: 'string',
    enum: ['grid', 'float'],
    defaultValue: 'float',
  },
  {
    name: 'backgroundColor',
    type: 'boolean',
    defaultValue: 'false',
  },
  {
    name: 'fullImage',
    type: 'boolean',
  },
  imageField('image'),
  {
    name: 'heading',
    type: 'string',
  },
  {
    name: 'eyebrow',
    type: 'string',
  },
  {
    name: 'email',
    type: 'string',
  },
  {
    name: 'phoneNumber',
    type: 'string',
  },
  {
    name: 'description',
    type: 'richText',
  },
  {
    name: 'callToAction',
    type: 'object',
    subFields: [
      {
        name: 'label',
        type: 'string',
      },
      {
        name: 'url',
        type: 'url',
      },
    ],
  },
] as const satisfies DeepReadonly<Input[]>;

const leadershipConfig = {
  name: 'Leadership',
  inputs: leadershipFields,
};

export type LeadershipProps = GenerateBuilder<typeof leadershipFields>;

export default leadershipConfig;
